import Vue from 'vue';
import { api } from "../../services/Api.js";

export function add_absence({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // make api call
    return api
    .post(school,"add_absence.php",payload)
    .then( result =>{ 
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: add_absence: "+error);
      return error;
    })

   
    
  }